export const createAllStoresRows = tableHeaders => [
  ['Loja', ...tableHeaders]
]

export const appendAllStoresRows = (allStoresRows, storeRows) => {
  allStoresRows.push(...storeRows)
}
